/**
 * HEIC/HEIF → JPEG for browsers that cannot decode iPhone photos natively.
 * `heic-to` (about 3 MB) is one of the two lazy libraries of the admin (plan
 * D12): it is loaded only when such a photo is picked.
 */
export async function heicToJpeg(file: File): Promise<Blob> {
  const { heicTo } = await import('heic-to');
  return heicTo({ blob: file, type: 'image/jpeg', quality: 0.92 });
}
